import React from 'react';
import { PartnersSection } from '../components/PartnersSection';
import { InsurancePartnersSection } from '../components/InsurancePartnersSection';
export function PartnersPage() {
  return <div className="bg-black" data-id="element-462">
      {/* Hero Section */}
      <section className="relative w-full bg-gradient-to-b from-gray-900 to-black py-20 px-4 sm:px-6 lg:px-8" data-id="element-463">
        <div className="max-w-5xl mx-auto text-center" data-id="element-464">
          <h1 className="text-4xl sm:text-5xl font-bold mb-6" data-id="element-465">
            Our <span className="text-[#4a7c59]" data-id="element-466">Partners</span>
          </h1>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto" data-id="element-467">
            Connect with experienced professionals and access exclusive services
            through our trusted network of partners.
          </p>
        </div>
      </section>
      <InsurancePartnersSection data-id="element-468" />
      <PartnersSection data-id="element-469" />
      {/* CTA Section */}
      <section className="py-20 px-4 sm:px-6 lg:px-8 bg-[#4a7c59]" data-id="element-470">
        <div className="max-w-4xl mx-auto text-center" data-id="element-471">
          <h2 className="text-3xl sm:text-4xl font-bold mb-6" data-id="element-472">
            Ready to Join Our Community?
          </h2>
          <p className="text-xl mb-10" data-id="element-473">
            Connect with successful investors and access exclusive partner
            benefits.
          </p>
          <a href="https://calendly.com/gregnamrow/1v1-meeting-tacticalinvestormastermind" target="_blank" rel="noopener noreferrer" className="bg-white text-black hover:bg-gray-200 font-bold py-3 px-8 rounded-md text-lg inline-block" data-id="element-474">
            Apply Now
          </a>
        </div>
      </section>
    </div>;
}